import { useState, useEffect } from 'react';
import { Stack } from '@mui/material';

import { TitlePage } from '../../components/TitlePage';
import { TableBasic } from '../../components/TableBasic';
import { dateFormmater } from '../../helpers';
import { FilterCertification } from './components/FilterCertification';

const subtitle = 'Consultar certificaciones';
const buttonTitle = 'Añadir una certificación';

export const CertificationScreen = ({ dataClient = [] }) => {
  const [filterArray, setFilterArray] = useState([]);
  const [copyArray, setCopyArray] = useState([]);

  useEffect(() => {
    if (Array.isArray(dataClient)) {
      const array = dataClient.map((est) => {
        let contactTel = 'Teléfono no disponible';
        const contactName = est?.work?.contact || 'Sin contacto';
        const clientName = est?.client?.name || 'Sin cliente';

        let contacts = [];

        try {
          const contactsData = est?.client?.contacts;

          // Si está definido y no es vacío
          if (contactsData) {
            if (typeof contactsData === 'string') {
              try {
                contacts = JSON.parse(contactsData);
              } catch {
                contacts = [];
              }
            } else if (Array.isArray(contactsData)) {
              contacts = contactsData;
            }
          }

          // Buscar el teléfono del contacto
          const found = contacts.find(c => c?.contactName === contactName);
          contactTel = found?.contactTel || contactTel;
        } catch (err) {
          console.warn(`❌ Error al procesar contactos del cliente ${est.client?.id} (${clientName})`, err);
        }

        return {
          id: est.id,
          name: clientName,
          addressWork: est.work?.addressWork || 'Sin dirección',
          contact: `${contactName} - Tel: ${contactTel}`,
          firstDate: dateFormmater(est.firstDate),
          lastDate: dateFormmater(est.lastDate),
        };
      });

      setCopyArray(array);
      setFilterArray(array);
    }
  }, [dataClient]);

  return (
    <Stack width='100%' alignItems='center' mt='2rem'>
      <Stack width='95%' alignItems='center'>
        <TitlePage title="Certificaciones" subtitle={subtitle} buttonTitle={buttonTitle} />
        <FilterCertification setFilterArray={setFilterArray} copyArray={copyArray} />
        <TableBasic setCopyArray={setCopyArray} tableTitle={tableTitle} rows={filterArray} colNames={colNames} values={values} setFilterArray={setFilterArray} />
      </Stack>
    </Stack>
  );
};

const colNames = ['Cliente', 'Dirección de obra', 'Contacto', 'Fecha inicio', 'Fecha fin', ''];
const values = ['id', 'name', 'addressWork', 'contact', 'firstDate', 'lastDate'];
const tableTitle = 'certification';

